import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import loginImg from './Images/login-img.svg';
import half from './Images/half.png';
import leftArrow from './Images/leftArrow.svg';
import showPass from './Images/eye-slash.svg'
import hidePass from './Images/eye.svg'
import { adminChangePassword } from './services/Api';

function ChangePassword() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);


  const initialValues = {
    oldPassword: '',
    newPassword: '',
  };

  const validationSchema = Yup.object({
    oldPassword: Yup.string()
      .required('Old Password is required')
      .min(6, 'Password must be at least 6 characters'),
    newPassword: Yup.string()
      .required('New Password is required')
      .min(6, 'Password must be at least 6 characters'),
  });

  const handleSubmit = (values, { setSubmitting }) => {
    adminChangePassword(values.oldPassword, values.newPassword)
      .then(response => {
        toast(response.data.message);
        setTimeout(() => {
          navigate('/admin/dashboard');
        }, 2000);
      })
      .catch(error => {
        toast(error.response?.data?.message || 'Something went wrong');
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <div className="block lg:flex h-fit">
        <div className="w-full lg:w-1/2 flex px-8 sm:px-12 lg:px-16">
          <div className="w-full">
            <div className="right-10 top-28 relative">
              <img className="h-24" alt="half" src={half} />
            </div>
            <img
              className="relative h-7 -mt-10 mb-10 cursor-pointer"
              onClick={() => navigate('/admin/dashboard')}
              alt="leftArrow"
              src={leftArrow}
            />
            <div>
              <h2 className="text-3xl font-semibold text-[#192326] mb-5">Change Password</h2>
            </div>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form className="space-y-8">
                  <div>
                    <label htmlFor="oldPassword" className="block text-sm font-semibold text-[#192326] mt-3">
                      Old Password
                    </label>
                    <div className=' relative'>
                      <Field
                        id="oldPassword"
                        name="oldPassword"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        className="mt-1 border-2 w-full outline-none ps-3 rounded-md h-9 text-[#535763]"
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-3 top-3 text-gray-400 hover:text-gray-300"
                      >
                        {showPassword ? (
                          <img alt='showPass' src={showPass} />
                        ) : (
                          <img alt='hidePass' src={hidePass} />
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="oldPassword"
                      component="div"
                      className="text-red-600 text-xs"
                    />
                  </div>
                  <div>
                    <label htmlFor="newPassword" className="block text-sm font-semibold text-[#192326] mt-3">
                      New Password
                    </label>
                    <div className=' relative'>
                      <Field
                        id="newPassword"
                        name="newPassword"
                        type={showNewPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        className="mt-1 border-2 w-full outline-none ps-3 rounded-md h-9"
                      />
                      <button
                        type="button"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        className="absolute right-3 top-3 text-gray-400 hover:text-gray-300"
                      >
                        {showNewPassword ? (
                          <img alt='showPass' src={showPass} />
                        ) : (
                          <img alt='hidePass' src={hidePass} />
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="newPassword"
                      component="div"
                      className="text-red-600 text-xs"
                    />
                  </div>
                  <div>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full bg-[#E53935] hover:bg-red-600 text-white rounded-md h-9 mt-8"
                    >
                      {isSubmitting ? 'Changing...' : 'Confirm'}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <div className="w-full lg:w-1/2 relative mt-5 lg:mt-0 bg-[url('./Images/login-image.svg')] bg-cover bg-center bg-no-repeat">
          <img className="h-full w-full scale-x-[-1]" alt="car" src={loginImg} />
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
